import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-label-form',
  templateUrl: './label-form.component.html',
  styleUrls: ['./label-form.component.less'],
})
export class LabelFormComponent implements OnInit {
  @Input() labelText: string;
  @Input() fieldControlName: string;
  @Input() formGroup: FormGroup;

  constructor() {}

  ngOnInit(): void {}
}
